import React from "react";

const ChevronLeft = ({ disabled, size = 16 }) => <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 12L6 8L10 4" stroke="#2D2C44" strokeOpacity={disabled ? .4 : .7} strokeWidth="1.5" strokeLinecap="round"
    strokeLinejoin="round" />
</svg>;

export default ChevronLeft;
